import React from "react";
import { Flex } from "@mantine/core";
import { useSelector } from "react-redux";
import { useAppSelector } from "../../../../../hooks";
import { IssueDashboardOptionsEnum } from "../../issueConstants";
import { selectIssueBoard } from "../../issueSelectors";
import BreeamDashboard from "./BreeamDashboard";
import IssueStandardDashboard from "./IssueStandardDashboard";
import RisikoDashboard from "./Risiko/RisikoDashboard";

const IssueDashboardMain: React.FC<{ projectId: string; issueBoardId: string }> = ({ projectId, issueBoardId }) => {
  const activeDashboardInRedux = useAppSelector((state) => state.issueReducerNew.activeDashboard);
  const issueBoard = useSelector(selectIssueBoard);

  const activeDashboard = activeDashboardInRedux != null ? activeDashboardInRedux : issueBoard?.dashboardSetting;

  return (
    <>
      <Flex direction="column" mx="0.25rem" style={{ overflow: "auto" }} w="100%">
        {activeDashboard === IssueDashboardOptionsEnum.STANDARD && <IssueStandardDashboard />}
        {activeDashboard === IssueDashboardOptionsEnum.BREEAM && (
          <BreeamDashboard projectId={projectId} issueBoard={issueBoard} />
        )}
        {activeDashboard === IssueDashboardOptionsEnum.BREEAM_PREANALYSE && <p>Hello BREEAM preanalyse-dashboard</p>}
        {activeDashboard === IssueDashboardOptionsEnum.RISIKO && <RisikoDashboard />}
      </Flex>
    </>
  );
};

export default IssueDashboardMain;
